import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { JwtAuthService } from './jwt-auth.service';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { OidcClaimTypes } from 'app/shared/constants/constants';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { LoginOauthSuccess } from 'app/root-store/auth/auth.action';
import { AutentifikacijaClient } from 'app/api/uk-api-reference';

@Injectable({
  providedIn: 'root'
})
export class IdentityAuthService {
  isAuthenticated: Boolean = false;

  constructor(
    private authConfig: AuthConfig,
    private oauthService: OAuthService,
    private autentifikacijaClient: AutentifikacijaClient,
    private jwtAuthService: JwtAuthService,
    private store: Store,
  ) {
    // setup oauthService
    this.oauthService.configure(this.authConfig);
    this.oauthService.silentRefreshRedirectUri = window.location.origin + "/silent-refresh.html";

    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
      this.oauthService.setupAutomaticSilentRefresh();
    });
  }

  login(url: string, params?: string) {
    sessionStorage.setItem('redirectUrl', url);   //pokusaj ulaska na stranicu ali je token istekao, redirectUrl ce se koristiti posle uspesnog logina
    if (params != null && params != '{}') {
      sessionStorage.setItem('queryParams', params)
    }
    this.oauthService.initCodeFlow();
  }

  postLogin() {
    this.isAuthenticated = true;
    let url = sessionStorage.getItem('redirectUrl');
    let queryParams: Params = null;

    if (sessionStorage.getItem('queryParams')) {
      queryParams = JSON.parse(sessionStorage.getItem('queryParams'));
      sessionStorage.removeItem('queryParams');
    }

    sessionStorage.removeItem('redirectUrl');

    this.oauthService.events
      .pipe(filter(e => e.type === 'token_received'), take(1))
      .subscribe(_ => {
        if (url != null) {
          this.autentifikacijaClient.prijavaJedinstveniIdentifikator(true).subscribe({
            next: (user) => {
              if (user) {
                this.jwtAuthService.setAuthorizedUserResponse(user);
                this.store.dispatch(new LoginOauthSuccess(user, true));
                url = null;
              }
              // sessionStorage.clear()
            },
            error: (err) => {
              this.jwtAuthService.failedLoginSource.next({
                failedLogin: true,
                statusCode: 400
              });
            }
          })
        }
      });
    return url;
  }

  // ne koristi se ova metoda za implicit flow - radi se automatski refresh tokena preko metode setupAutomaticSilentRefresh()
  refreshToken(): void {
    if (this.oauthService.hasValidAccessToken()) {
      this.oauthService.refreshToken();
    }
  }

  isLoggedIn() {
    return this.oauthService.hasValidAccessToken() && this.isAuthenticated;
  }

  logOut(noRedirectToLogoutUrl = false) {
    this.oauthService.logOut(noRedirectToLogoutUrl);
  }

  public get name() {
    let claims = this.oauthService.getIdentityClaims();
    if (!claims || !this.isLoggedIn()) return 'anonymous';
    return claims["sub"];
  }

  public get jmbg() {
    let claims = this.oauthService.getIdentityClaims();
    if (!claims || !this.isLoggedIn()) return '';
    return claims["http://schema.id.rs/claims/umcn"];
  }

  public get email() {
    let claims = this.oauthService.getIdentityClaims();
    if (!claims || !this.isLoggedIn()) return 'anonymous';
    return claims[OidcClaimTypes.EMAIL];
  }
}
